import React, { useEffect, useState } from 'react';
import { ImArrowUp2 } from "react-icons/im";

const ScrollButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollHeight = window.innerHeight - 500;
            const currentScroll = window.scrollY;

            if (currentScroll > scrollHeight) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <button
            className={isVisible ? 'scroll-button visible' : 'scroll-button'}
            onClick={scrollToTop}
        >
            <ImArrowUp2 className='icon' />
        </button>
    );
};

export default ScrollButton;